import React,{Component} from 'react';
import {Switch, Route, withRouter, Redirect} from 'react-router-dom';
import { connect } from 'react-redux';
import Welcome from './../../pages/setup/Welcome';
import OfficeSetupNavBar from './OfficeSetupNavBar';
import PersonalDetails from '../../pages/setup/office/PersonalDetails';
import OfficeDetails from '../../pages/setup/office/OfficeDetails';
import AddMembers from '../../pages/setup/office/AddMembers';
import SelectEnterpriseIndustry from '../../pages/setup/SelectEnterpriseIndustry';
import OrgChartSetup from '../../pages/setup/organization/OrgChartSetup/OrgChartSetup';
import MapGenderSetup from '../../pages/setup/organization/MapGenderSetup/MapGenderSetup';
import MapPositionsSetup from '../../pages/setup/organization/MapPositionsSetup/MapPositionsSetup';
import MapPerformanceSetup from '../../pages/setup/organization/MapPerformanceSetup/MapPerformanceSetup';
import MapEthnicitySetup from '../../pages/setup/organization/MapEthnicitySetup/MapEthnicitySetup';

import OrgOverview from '../../pages/setup/OrgOverview';


import MapSeparationSetup from '../../pages/setup/organization/MapSeparationSetup/MapSeparationSetup';
import ChooseUploadCategory from '../../pages/upload-data/ChooseUploadCategory';
import CsvUpload from '../../pages/upload-data/Csv/CsvUpload';
import ManualDataEntry from '../../pages/upload-data/Manual/ManualDataEntry';
import UploadSuccess from '../../pages/upload-data/UploadSuccess';
import UploadDataLanding from '../../pages/setup/office/UploadDataLanding';
import { isMobile } from '../../utils/deviceInfo';

class OfficeSetup extends Component {


  render(){
    // const {isOfficeConfigured,isMembersAdded } = this.props;
    // const {isProfileDetailsUpdated} = this.props;
    console.log(this.props)


    let setupRoutes = (<Switch>
      <Route exact path={this.props.match.url + '/welcome'} component={Welcome} />
      <Route exact path={this.props.match.url + '/personal-details'} component={PersonalDetails} {...this.props} />
      {/* <Route exact path={this.props.match.url + '/office-details'} component={OfficeDetails} /> */}
      <Route exact path={this.props.match.url + '/add-members'} component={AddMembers} {...this.props}/>
      <Redirect exact path={this.props.match.url} to={this.props.match.url + '/welcome'} />
    </Switch>);




    if(this.props.user.role==='Member'){
          setupRoutes =(<Switch>
            <Route exact path={this.props.match.url + '/welcome'} component={Welcome} />
            <Route exact path={this.props.match.url + '/personal-details'} component={PersonalDetails} />
            <Redirect exact path={this.props.match.url} to={this.props.match.url + '/welcome'} />
          </Switch>);
    }


    // if(this.props.user.orgAdmin ||){

    // }

    if(this.props.user.orgAdmin) {
      setupRoutes = (<Switch>
        <Route exact path={this.props.match.url + '/welcome'} component={Welcome}/>
        <Route exact path={this.props.match.url + '/personal-details'} component={PersonalDetails}/>
        <Route exact path={this.props.match.url + '/office-details'} component={OfficeDetails}/>
        <Route exact path={this.props.match.url + '/add-members'} component={AddMembers}/>
        <Route exact path={this.props.match.url + '/upload-data-landing'} component={UploadDataLanding} />
        <Route exact path={this.props.match.url + '/upload-data-category'} component={ChooseUploadCategory} />
        <Route exact path={this.props.match.url + '/upload-data/csv'} render={() => <CsvUpload isSetupFlow={true} {...this.props}/>}/>
        <Route exact path={this.props.match.url + '/upload-data/success'} component={UploadSuccess}/>
        <Route exact path={this.props.match.url + '/upload-data/manual'} render={() => <ManualDataEntry isSetupFlow {...this.props}/>}/>
        <Route exact path={this.props.match.url + '/select-industry'} component={SelectEnterpriseIndustry}/>
        
        
        <Route exact path={this.props.match.url + '/org-overview'} component={OrgOverview}/>
        
        
        <Route exact path={this.props.match.url + '/org-chart'} component={OrgChartSetup}/>
        <Route exact path={this.props.match.url + '/map-gender'} component={MapGenderSetup}/>
        <Route exact path={this.props.match.url + '/map-positions'} component={MapPositionsSetup}/>
        <Route exact path={this.props.match.url + '/map-performance'} component={MapPerformanceSetup}/>
        <Route exact path={this.props.match.url + '/map-ethnicity'} component={MapEthnicitySetup}/>
        <Route exact path={this.props.match.url + '/map-separation'} component={MapSeparationSetup}/>
        <Redirect exact path={this.props.match.url + '/upload-data'} to={this.props.match.url + '/upload-data-landing'}/>
        <Redirect exact path={this.props.match.url} to={this.props.match.url + '/welcome'}/>
      </Switch>);
    }

    return(
      <div>
        <div>
        <OfficeSetupNavBar {...this.props} />
        {/* pb150 */}
        <div className="container-fluid mt69">
            <div className="row">
              <main role="main"
                className={`col-lg-8 offset-lg-2 col-md-12 col-md-offset-right-2 ${!isMobile && 'pr0'} `}>
                {setupRoutes}
              </main>
          </div>
        </div>
      </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    user : state.user.profile
  }
}

export default connect(mapStateToProps)(OfficeSetup);
